import { Checkbox, FormControlLabel } from '@mui/material'
import { useCanOptOutOfUnreadMessagePopups, useHideUnreadMessagePopups } from '@src/hooks/unreadMessagePopup-hooks'
import { useTranslation } from 'react-i18next'

const HideUnreadMessagePopupsCheckbox = () => {
  const { t } = useTranslation()
  const canOptOut = useCanOptOutOfUnreadMessagePopups()
  const [hidden, setHidden] = useHideUnreadMessagePopups()

  if (!canOptOut) return null

  return (
    <FormControlLabel
      control={
        <Checkbox id="hideUnreadMessagePopups" checked={hidden} onChange={(event) => setHidden(event.target.checked)} />
      }
      label={t('common.hideUnreadMessagePopups')}
    />
  )
}

export default HideUnreadMessagePopupsCheckbox
